const font_family_position = {
        basic_text_rich_type: [],
        basic_picture: [],
        basic_button: ['pc_widgets_infor.font', 'pc_widgets_infor.fontStyle'],
        basic_notice: ['pc_widgets_infor.font'],
        basic_flod_text_list: ['pc_widgets_infor.title_font', 'pc_widgets_infor.title.font'],
        basic_rich_text: [],
        basic_list_photos: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_banner: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_article_list: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.font'],
        basic_atlas_catalog: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_product_display: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.product_name_font'],
        basic_video: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.text_set'],
        basic_crumbs: ['pc_widgets_infor.font'],
        basic_icon_combination: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.titleFont', 'pc_widgets_infor.summaryFont'],
        basic_picture_text_swiper: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.titleFont', 'pc_widgets_infor.summaryFont'],
        basic_development_history: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.titleFont'],
        basic_nleavemessage: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.form_title', 'pc_widgets_infor.form_item_title', 'pc_widgets_infor.form_item_content'],
        basic_searchs: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_article_classification: ['pc_widgets_infor.font', 'mb_widgets_infor.font'],
        basic_classification: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.font_level_1', 'pc_widgets_infor.font_level_2', 'pc_widgets_infor.font_level_3'],
        basic_map: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_download: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font', 'pc_widgets_infor.font'],
        basic_embed_page: ['pc_widgets_infor.title.font', 'mb_widgets_infor.title.font'],
        basic_plugin_code: [],
        basic_magic_number: ['pc_widgets_infor.font', 'mb_widgets_infor.font'],
        basic_progress: ['pc_widgets_infor.font', 'mb_widgets_infor.font'],
        layout_row: [],
        basic_row_tab: ['pc_widgets_infor.title.font', 'pc_widgets_infor.tagFont', 'pc_widgets_infor.tagFontSelect'],
        basic_navbar: ['pc_widgets_infor.navfont', 'pc_widgets_infor.navChildfont'],
        basic_language: ['pc_widgets_infor.text_style'],

    }


export default font_family_position


// WEBPACK FOOTER //
// ./src/base/font_family_position.js